import React from "react"
import { useNoteContext } from "./note-context"
import { cn } from "../utils"

export type NoteHeadingProps = {
  children: React.ReactNode
  className?: string
  /** The heading level, to fit the heading order around the note. It sets the tag only, so the heading looks the same at every level. Defaults to `2`. */
  level?: 2 | 3 | 4 | 5 | 6
}

export function NoteHeading({
  children,
  level = 2,
  className
}: NoteHeadingProps) {
  const { headingId, registerHeading } = useNoteContext()
  const HeadingTag = `h${level}` as const

  React.useLayoutEffect(() => registerHeading(), [registerHeading])

  return (
    <HeadingTag
      className={cn("shrink-0 text-sm leading-6 font-semibold", className)}
      data-slot="note-heading"
      id={headingId}
    >
      {children}
    </HeadingTag>
  )
}
